<template>
  <img src="../../public/demo-logo-plumb.png" alt="romoni logo" class="logo" style="height: 45px" />
</template>

<script lang="ts" setup></script>
